import React, { Component, Fragment } from 'react';
import NavigationItem from '~/UI/Navigation/Item/NavigationItem';

export interface Access {
	irp: boolean;
	analytics: boolean;
	search: boolean;
	productGroups: boolean;
	availability: boolean;
}

interface Props {
	erpm?: boolean;
	access: Access | null;
}

export default class NavigationMenu extends Component<Props> {
	static defaultProps = {
		access: null,
	};

	render() {
		const { access, erpm } = this.props;
		if (!access) {
			return null;
		}

		return (
			<Fragment>
				{access.irp ? (
					<NavigationItem activePaths={['/irp']} to='/irp/'>
						IRP
					</NavigationItem>
				) : null}
				{access.analytics ? (
					<NavigationItem activePaths={['/analytics']} to='/analytics/'>
						Analytics
					</NavigationItem>
				) : null}
				{access.search ? (
					<NavigationItem activePaths={['/search']} to='/product-groups/'>
						Search
					</NavigationItem>
				) : null}
				{access.productGroups ? (
					<NavigationItem activePaths={['/product-groups/:x']} to='/product-groups/#product-list'>
						Product List
					</NavigationItem>
				) : null}
				{access.availability ? (
					<NavigationItem activePaths={['/availability']} to='/availability'>
						Availability
					</NavigationItem>
				) : null}
				<NavigationItem to='/datasources'>Datasources</NavigationItem>
				<NavigationItem to='/notifications'>Notifications</NavigationItem>
				<NavigationItem to='/help'>Help</NavigationItem>
			</Fragment>
		);
	}
}
